module.exports = function() {
  return new Worker(__webpack_public_path__ + "ee189b324de6ae23f92a.worker.js");
};